import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  corpoFormulario: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 40,
  },
  card: {
    background: theme.palette.background?.default || '#f4f6f8',
    marginBottom: theme.spacing(2),
  },
  cardContent: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(2),
  },
  filiacao: {
    marginBottom: theme.spacing(1.5),
  },
  botaoAddFiliacao: {
    marginLeft: theme.spacing(1),
  },
  secaoRegistros: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  divider: {
    margin: '40px 0 24px 0',
    height: '1px',
    backgroundColor: theme.palette.divider,
  },
  navigationContainer: {
    padding: '8px 4px',
  },
  botaoAdicionar: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}))
